import { type ReactNode } from "react";

import {
  TableSearchContext,
  type TableSearchContextValue,
} from "./TableSearchContext";

interface TableSearchProviderValueProps {
  value: TableSearchContextValue;
  children: ReactNode;
}

export function TableSearchProviderValue(props: TableSearchProviderValueProps) {
  return (
    <TableSearchContext.Provider value={props.value}>
      {props.children}
    </TableSearchContext.Provider>
  );
}
